<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
     <z-page :title="title">
      <div class="table_scrol">
         <div class="w-card__content content-hardcode mb3">
          <w-form v-model="valid" @validate="cari" ref="frm">
            <w-flex class="mt3">
              <w-input style="margin:5px; " v-model="pencarian.no_permohonan" :items="no_permohonan" label="No Kes"/>
              <w-input style="margin:5px; " v-model="pencarian.ternakan_id" :items="ternakan_id" label="ID Ternakan" />
              <z-select style="margin:5px; " v-model="pencarian.jantina" :items="jantina" label="Jantina" />
            </w-flex>
          </w-form>
          <w-flex justify-end class="mt2">
              <w-button class="mr2" v-on:click="resetPencarian()" bg-color="warning">
                  <w-icon>fal fa-redo</w-icon>&nbsp;SET SEMULA</w-button>
              <w-button class="mr2" bg-color="primary" @click="$refs.frm.validate()">
                  <w-icon>fal fa-search</w-icon>&nbsp;CARI
              </w-button>
          </w-flex>
        </div>
        <w-dialog
            v-model="dialog.show"
            :fullscreen="dialog.fullscreen"
            :width="dialog.width"
            :persistent="dialog.persistent"
            :persistent-no-animation="dialog.persistentNoAnimation"
            title-class="primary-dark1--bg white">
            <template #title>
              <w-icon class="mr2">fal fa-cog</w-icon>
              {{dialog.title}}
            </template>
             <w-form ref="form" 
               v-model:errors-count="form.errorsCount"
               v-model="dialog.valid"
               @validate="simpan"
               @success="success" 
               >
         
                <div class="w-flex wrap smd-column" >
                  <div class="grow " >
                    <w-flex wrap :gap="2">
                       <div class="grow mb4" style="min-width: 200px">
                          <w-input class="mt4" label="Tarikh Temu Janji Penilaian *" type="date" v-model="form.tarikh_temujanji" :validators="[validators.required]"/>
                          <w-select class="mt4" :items="penilai" label="Nama Pegawai Penilaian *"  v-model="form.penilai_id"  :validators="[validators.required]"/>
                        </div>
                    </w-flex>
                 </div>
              </div>
           </w-form>

            
            <template #actions>
              <div class="spacer" />
              <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog.show = false">TUTUP</w-button>
               <w-button 
                  class="ml1" 
                  :loading="dialog.loading"
                  v-if="dialog.loading===false"
                  :disabled="dialog.valid === false"
                  @click="$refs.form.validate()"
                  >

                    SIMPAN
                  </w-button>
                  <w-button 
                  class="ml1" 
                  :loading="dialog.loading"
                  v-if="dialog.loading===true"
                  disabled
                  @click="$refs.form.validate()"
                  >
                    SIMPAN
                  </w-button>
           </template>
         </w-dialog>
        <z-table title="Senarai Permohonan Penilaian Daya Biak & Fertiliti" :headers="table.headers" :items="table.items" :meta="table.meta" :mobile-breakpoint="700">
            <!-- <template #button v-if="$zutil.role('4')">
               <w-tooltip md top color="white" bg-color="black" >
                  <template #activator="{ on }">
                <w-button dark class="green--bg ml1" :route="$route('pdbf.penilaian.form',0)" v-on="on" ><div style="width: 5px"></div>
                    <w-icon md class="mr1">fal fa-print</w-icon>
                </w-button><div style="padding-right: 45px"></div>
             </template>
                Cetak Borang
             </w-tooltip>
            </template> -->
            &nbsp;
          <template #header-label="{ header, label, index }">
            <template v-if="header.key == 'action'">
               <!-- <w-icon xs>fal fa-pencil</w-icon> -->
              Tindakan
            </template>
            <template v-else>
               {{ label }}
            </template>
          </template>
          <template #item-cell.action="{ item, label, header, index }">
            <w-flex class="flex justify-center">
              <w-tooltip top color="white" bg-color="black">
                 <template #activator="{ on }">
                    <w-button  bg-color="warning" v-on="on" v-if="item.lkp_status_id !=31 && item.lkp_status_id !=32 && item.lkp_status_id !=18 && item.lkp_status_id !=35 && $zutil.anyRole(['4'])" :route="$route('pdbf.penilaian.form',item.id)" class="be fs-2"><div style="width: 8px"></div>
                    <w-icon md class="mr2">fal fa-pencil</w-icon>
                    </w-button>
                  </template>
                  Kemaskini
                </w-tooltip>
                &nbsp;
              <w-tooltip md top align-right color="white" bg-color="black">
                 <template #activator="{ on }">
                    <inertia-link :href="$route('pdbf.penilaian.sejarah', item.ternakan_id)" v-on="on" class="w-button w-button--dark size--md info-dark1--bg"> <div style="width: 8px"></div>
                      <w-icon md class="mr2">fal fa-history</w-icon>
                    </inertia-link>
                  </template>
                  Sejarah
                </w-tooltip>
            </w-flex>
          </template>

        </z-table>
      </div>
     </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'pdbf.penilaian',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Penilaian Daya Biak & Fertiliti', route: '/pdbf' },
        { label: 'Penilaian', route: '/pdbf/penilaian' },
      ],
      title : 'Pdbf Penilaian',
      form : this.d_form,
      
      
      pencarian: {
         no_permohonan: '',
         ternakan_id: '',
         jantina: '',
      },
      no_permohonan: [],
      ternakan_id:[],
      jantina:[],
      
      
    }
  },
  methods: {
     add(){
          this.form = {
              id : 0,
              penilai_id : '',
              tarikh_temujanji : '',
              

          }
          
          this.dialog.show = true
          this.dialog.title = 'Tarikh Temu Janji Penilaian '
          this.form.saveButton = "Simpan"
      },

   cari() {
       if(!this.valid) return;

       let params = {
       ...this.pencarian,
       };
       params.page = 1;
       this.$inertia.visit(route(route().current(), params), {
           preserveState: true,
           preserveScroll: true,
       });
    },

    resetPencarian() {
       this.$inertia.visit(route(route().current()));
    },

    getStatus(){
      this.$zcomm.get(this.api_service + 'lookup/status_art', {}).then(res => {
        this.lkp_status = res
      })
    },

    destroy1(id)
    {
      this.$swal({
        title: 'Anda Pasti?',
        // text: "Are you sure want to delete this item!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya',
        cancelButtonText: 'Tidak'
      }).then((result) => {
        if (result.value) {
          this.$zcomm.delete(this.resourceurl + '.destroy',id)
          .then(res => {
            this.sending = false;
            this.$inertia.visit(this.$page.url)
            this.removeitem(res) // remove the data from list. no need to refresh page
            if (typeof this.onAfterDelete === "function") {
              this.onAfterDelete()
            }
          })
          .finally(() => {
            // $('#' + this.resourceurl).modal('hide')
          });
        }else{ }
        })

    },

    getPremis(){
     this.$zcomm.get(this.api_service + 'lookup/premis', {}).then(res => {
       this.premis = res
     })
   },

   getPremisCarian(){
         this.$zcomm.get(this.api_service + 'lookup/premis', {}).then(res => {
           this.premis_id = res
         })
       },

    getPenilai(){
         this.$zcomm.get(this.api_service + 'lookup/pemeriksa', {}).then(res => {
           this.penilai = res
         })
       },

    getJantina(){
         this.$zcomm.get(this.api_service + 'lookup/jantina', {}).then(res => {
           this.jantina = res
         })
       },

    simpan(){
         this.dialog.loading = true
         if(this.dialog.valid == true){
            if (this.form.id > 0) 
            {
              this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
              .then(res => {
                if (typeof this.onAfterEdit === "function") {
                  this.onAfterEdit()
                }
               this.$inertia.visit(route(route().current()));
               this.dialog.loading = false
               this.dialog.show = false
                // this.loading = 0;
              })
            }
            else 
            {
              this.$zcomm.post(this.resourceurl+'.store' , this.form)
              .then(res => {
                if (typeof this.onAfterAdd === "function") {
                  this.onAfterAdd()
                }
                this.$inertia.visit(route(route().current()));
               this.dialog.loading = false
               this.dialog.show = false

                // this.loading = 0;

              })
            }
         }else{
            this.dialog.loading = false
         }
       },


    onSuccess(tindakan, pdbf_id){
      this.$swal({
          title: 'Anda Pasti?',
          // text: "Are you sure want to delete this item!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak'
        }).then((result) => {
          if (result.value) {
            if (pdbf_id > 0){
              this.$zcomm.update(this.resourceurl + '.tindakan', pdbf_id, {tindakan :tindakan})
              .then(res => {
                if (typeof this.onAfterEdit === "function") {
                  this.onAfterEdit()
                }
                if (tindakan==1) {
                    this.$zutil.notify("Berjaya disimpan", true);
                }else{
                  this.$zutil.notify("Berjaya ditolak", false);
                }
                this.$inertia.visit(this.$route(this.resourceurl+'.index'))
              })
            }
          }
        })
      
    },
    
  
  },

  watch: {

  },
  mounted() {
   if(this.id > 0)
    {
      this.title = 'Permohonan Penilaian Daya Biak & Fertiliti'
    }
    else
    {
      this.title = 'Permohonan Penilaian Daya Biak & Fertiliti'
    }
   this.getStatus();
   this.getPremis();
   this.getPenilai();
   this.getJantina();
   this.getPremisCarian();
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>
